import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Quote as Block } from "./QuoteBlock";
import { defaultData } from "./QuoteDefaultData";
import { meta } from "./QuoteMetaData";

export const QuoteBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-quote",
    size: 24,
  },
  defaultData,
  meta,
};
